import { Component, Input } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { AttachmentDto } from "../../../core/dto/attachment.dto";
import { OrderDto } from "../../../core/dto/order.dto";
import { AttachmentHelper } from "../../../core/helpers/attachment.helper";
import { AttachmentKinds } from "../../../core/interfaces/attachmentKinds";
import { AttachmentService } from "../../../core/services/attachment.service";
import { LoadingHelper } from "../../../gyzmo-commons/helpers/loading.helper";
import { isNullOrEmpty } from "../../../gyzmo-commons/helpers/null.helper";
import { PictureHelper } from "../../../gyzmo-commons/helpers/picture.helper";
import { DateProvider } from "../../../gyzmo-commons/interfaces/dateProvider";

@Component({
    templateUrl: "departure-signature.popover.html",
    styleUrls: ["departure-signature.popover.scss"],
})
export class DepartureSignaturePopover {
    @Input() order: OrderDto;

    customerSignature: string = "";

    constructor(private dateProvider: DateProvider,
                private popoverController: PopoverController,
                private loadingHelper: LoadingHelper,
                private pictureHelper: PictureHelper,
                private attachmentService: AttachmentService) {
    }

    public dismiss(data?: any) {
        void this.popoverController.dismiss(data);
    }

    public async saveSignature() {
        await this.loadingHelper.showLoading();

        let movementKY = this.order.id;

        let currentDate = this.dateProvider.now();

        if (!isNullOrEmpty(this.customerSignature)) {
            let customerSignature: AttachmentDto = await AttachmentHelper.createPhotoWithLegend(this.pictureHelper,
                this.dateProvider,
                this.customerSignature,
                movementKY);
            customerSignature.attachmentKind.id = AttachmentKinds.SIGNATURE;
            customerSignature.object = "longTermContract";
            customerSignature.date = currentDate;
            customerSignature.key = movementKY;
            customerSignature.wording = "Signature client départ";

            await this.attachmentService.save(customerSignature.toModel());
        }

        await this.loadingHelper.hideAll();

        await this.dismiss(true);
    }
}
